module.exports = __webpack_public_path__ + "media/icons/file-54534a4f.svg";